<template>
   <el-container class="content" style="display: block;">


     <div :style="{'width':otherWidth+'px','height':leftheight+'px'}" style="display: flex;flex-wrap: wrap;background-color: #000;overflow-y: scroll;">

       <!-- <img :src="video['img']"  :width="vwidth" :height="vwidth" @click="open(video['url'])"> -->
      <div v-for="(video, index) in list" :key="index" >


        <div class="donghuap" :style="{'width':vwidth+'px','height':vwidth+'px'}">
          <!-- <img :src="require('@/assets/image/ceshi.gif')"  :width="vwidth" :height="vwidth" > -->
          <!-- <div @click="open(video['url'])"  class="donghuai" :class="{ddonghua:(video['typed'] == 0),edonghua:(video['typec'] == 1),adonghua:(video['typea'] == 1)}" :style="{'background-image':`url(${video['bkg']})`}">

            <img :src="video['img']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
          </div>

          <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}" class="donghuai" @click="open(video['url'])"  :style="{'width':vwidth+'px','height':vwidth+'px','line-height':vwidth+'px','margin-left':'-'+vwidth+'px'}" style="color: #ffffff;text-align: center;" >{{video['ci']}}</div>
        -->
          <div @click="open(video['url'])"  :style="{'background-image':`url(${video['bkg']})`}">
            <video v-if="video['v_url'] != '无'" autoplay loop muted playsinline style="object-fit: contain;" :style="{'width': vwidth+'px','height': vwidth+'px'}">
              <source :src="video['v_url']" type="video/mp4" />
            </video>
            <img v-else :src="video['img']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
            <!-- <img :src="video['img']"  :width="vwidth" :height="vwidth" style="object-fit: contain;"> -->
          </div>
          <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}" class="donghuai" @click="open(video['url'])"  :style="{'width':vwidth+'px','height':vwidth+'px','margin-left':'-'+vwidth+'px'}" style="color: #ffffff;text-align: center;" >
           <!-- <div :style="{'margin-top':vwidth*0.75+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}" style="background-color: #000;white-space: nowrap;overflow: hidden;">{{video['ci']}}</div> -->
           <div class="shop2_wenzi" :style="{'margin-top':vwidth*0.75+'px','width':vwidth+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}" style="white-space: nowrap;overflow: hidden;">{{video['ci']}}</div>
          </div>

        </div>

       </div>




     </div>
    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;"  :style="{'width':screenHeight+'px','height':screenHeight+'px','left':otherWidth+'px'}">
      <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo" v-if="ishow" >
        <source :src="video_url" type="video/mp4">

      </video>
      <!-- <div style="position: absolute;z-index: 1010;bottom: 2px;":style="{'right':0+'px'}">
        <div style="background-color: #000;color: #fff;padding-left: 5px;padding-right: 5px;border: 1px solid #fff;" @click="down()"><a  style="color: #fff;">能力文档</a></div>
        <div style="background-color: #000;color: #fff;padding-left: 5px;padding-right: 5px;border: 1px solid #fff;"><a :href="downUrl2" style="color: #fff;">报价清单</a></div>
        <div style="background-color: #000;color: #fff;padding-left: 5px;padding-right: 5px;border: 1px solid #fff;"><a :href="downUrl3" style="color: #fff;">生产合同</a></div>
      </div> -->
      <div class="grid_b">
        <div class="cell_b">
            <img :src="require('@/assets/image/hetong.png')" alt="Icon 1" class="icon_b">
            <p class="text_b">合同</p>
        </div>
        <div class="cell_b">
            <img :src="require('@/assets/image/nenglibiao.png')" alt="Icon 2" class="icon_b">
            <p class="text_b">能力表</p>
        </div>
        <div class="cell_b">
            <img :src="require('@/assets/image/baojiadan.png')" alt="Icon 3" class="icon_b">
            <p class="text_b">报价单</p>
        </div>
        <div class="cell_b" @click="zongjiashow=true">
            <img :src="zongjiapayImge" alt="Icon 4" class="icon_b" v-if="zongjiaPayImgStatus == 0 && xq['status_pay'] != 1" >
            <img :src="zongjiaPayImg" alt="Icon 4" class="icon_b" v-if="zongjiaPayImgStatus == 1 && xq['status_pay'] != 1">
            <p class="text_b" v-if="xq['status_pay'] != 1">付款码</p>

            <img :src="require('@/assets/image/kf.png')" alt="Icon 4" class="icon_b" v-if="xq['status_pay'] == 1 && xq['status'] != 5">
            <p class="text_b" v-if="xq['status_pay'] == 1 && xq['status'] != 5">开发中</p>

            <img :src="xq.web_img" v-if="xq['status'] == 5" @click="webImgShow=true"  alt="Icon 3" class="icon_b" >
            <p class="text_b" v-if="xq['status'] == 5" >下载</p>
        </div>
        <img :src="zongjiapayImge" @click="getOnece1()" v-if="zongjiashow && zongjiaPayImgStatus == 0 && xq['status_pay'] != 1" style="width: 100%;height: 100%;z-index: 99999;position: absolute;top:0;left:0;"/>
        <img :src="zongjiaPayImg"  @click="zongjiashow=false" v-if="zongjiashow && zongjiaPayImgStatus == 1 && xq['status_pay'] != 1"  style="width: 100%;height: 100%;z-index: 99999;position: absolute;top:0;left:0;" />

        <img :src="xq.web_img" v-if="this.xq.status == 5 && webImgShow"  @click="webImgShow=false"  style="width: 100%;height: 100%;z-index: 99999;position: absolute;top:0;left:0;" />
      </div>
      <div class="float-animation" style="z-index: 1006;color: #ffffff;position: absolute;top: 10%;border: 1px solid #fff;" v-if="dinggou2 == 2" @click="dg(1)">
        <img :src="dinggou"  :width="120" :height="100" style="object-fit: contain;">
        <div style="text-align: center;">全球订购</div>

      </div>
      <div class="float-animation1" style="z-index: 1006;color: #ffffff;position: absolute;top: 10%;border: 1px solid #fff;" v-if="daili2 == 2" @click="dl(1)">
        <img :src="daili"  :width="120" :height="100" style="object-fit: contain;">
        <div style="text-align: center;">全球代理</div>

      </div>
      <div  style="z-index: 1006;color: #ffffff;position: absolute;bottom: 0;right:0%;border: 1px solid #fff;width: 40%;height: 40%;background-color: #000;" v-if="daili2 == 1" >
        <div style="color: #fff;text-align: center;margin-top: 2%;">全球代理</div>
        <el-row :span="2" style="margin-top: 10%;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              称呼:
            </el-col>
            <el-col :span="16">
              <el-input v-model="qiye" style="width: 200px;" placeholder="请输入您的姓名/公司名"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              电话:
            </el-col>
            <el-col :span="16">
              <el-input v-model="email" style="width: 200px;" placeholder="请输入您的手机号"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              其他:
            </el-col>
            <el-col :span="16">
              <el-input v-model="other" style="width: 200px;" placeholder="请输入您的其他联系方式"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 20px;margin-left: 30%;">
            <el-button type="primary" style="background-color: #409eff;" @click="commitdl()" round>提交</el-button>
        </el-row>
        <div  style="z-index: 1006;color: #ffffff;" v-if="daili" @click="dg()">
          <img :src="daili"  width="80%" height="80%" style="object-fit: contain;position: absolute;bottom: 0;right: -20%;">


        </div>
        <div style="position: absolute;right:2px;top:2px;" @click="dl(2)"><i class="el-icon-circle-close" style="font-size: 25px;color: #ffffff;"></i></div>
      </div>
      <div  style="z-index: 1006;color: #ffffff;position: absolute;bottom: 0;border: 1px solid #fff;width: 40%;height: 40%;background-color: #000;" v-if="dinggou2 == 1" >
        <div style="color: #fff;text-align: center;margin-top: 2%;">全球订购</div>
        <el-row :span="2" style="margin-top: 10%;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              称呼:
            </el-col>
            <el-col :span="16">
              <el-input v-model="qiye1" style="width: 200px;" placeholder="请输入您的姓名/公司名"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              电话:
            </el-col>
            <el-col :span="16">
              <el-input v-model="email1" style="width: 200px;" placeholder="请输入您的手机号"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              其他:
            </el-col>
            <el-col :span="16">
              <el-input v-model="other1" style="width: 200px;" placeholder="请输入您的其他联系方式"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 20px;margin-left: 30%;">
            <el-button type="primary" style="background-color: #409eff;" @click="commitdg()" round>提交</el-button>
        </el-row>
        <div  style="z-index: 1006;color: #ffffff;" v-if="dinggou" @click="dg()">
          <img :src="dinggou"  width="80%" height="80%" style="object-fit: contain;position: absolute;bottom: 0;right: -20%;">


        </div>
        <div style="position: absolute;right:2px;top:2px;" @click="dg(2)"><i class="el-icon-circle-close" style="font-size: 25px;color: #ffffff;"></i></div>
      </div>
    </div>

    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;overflow-y: scroll;"  :style="{'width':otherWidth+'px','height':screenHeight+'px','right':0}">
      <ul style="color: #000000;width: 100%;overflow-y: scroll;display: flex;flex-direction: column;">

        <li v-for="(item, index) in texts" :key="index" @click="open(item['url'])" style="box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.5);padding: 1px;" :style="{'background-color':'#'+item['color']}">{{item['name']}}</li>


      </ul>

    </div>
    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>

   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        qiye:'',
        email:'',
        other:'',
        qiye1:'',
        email1:'',
        other1:'',
        dlurl:'',
        dgurl:'',
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        vshow:false,
        list:[],
        shopkb:[],
        daili2:3,
        dinggou2:3,
        daili:'',
        dinggou:'',
        dailis:[],
        dinggous:[],
        texts:[],
        ishow:true,
        videos:[],
        video_url:'',
        id:this.$route.query.id,
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        otherWidth:(window.innerWidth-window.innerHeight)/2,
        vwidth:((window.innerWidth-window.innerHeight)/2-12)/6,
        vheight : window.innerHeight/200,
        leftheight:0,
        downUrl1:'',
        downUrl2:'',
        downUrl3:'',
        zongjiaPayImg:'https://images.yoooooo.com/crm/yzzm.jpg',
        zongjiashow:false,
        zongjiaPayNo:0,
        zongjiaPayImgStatus:1,
        zongjiapayImge:'https://images.yoooooo.com/crm/reseller/ewme.png',
        pollingInterval1:null,
        zongjiaPrice:0,
        xq:{},
        webImgShow:false
      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()
      this.getScreen()



    },

	methods:{
    getOnece1(){
      if(this.zongjiaPrice>0){
        const form = {'info':this.id,'price':this.zongjiaPrice}
        this.getErweima1(form)
      }

    },
    getErweima1(form){
      this.stopPolling1()
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/pays/hetongWxPay'
      })
      .then(res=>{
        // console.log(res.data)
        if(res.data.code == 200){
          this.zongjiaPayImg = res.data.data
          this.zongjiaPayNo = res.data.no
          this.zongjiaPayImgStatus = 1
          this.startPolling1()
          // this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.msg,'error');
        }

      })
      .catch(err=>{

      });
    },
    startPolling1() {
      var status = 1;
      this.pollingInterval1 = setInterval(() => {
        status = status+1;
        if(status > 20){
          this.zongjiaPayImgStatus = 0
          this.zongjiaPayImg = ''
          this.stopPolling1()
        }
        // this.getPayStatus();
      }, 1000);
    },
    stopPolling1() {
      if (this.pollingInterval1) {
        clearInterval(this.pollingInterval1);
        this.pollingInterval1 = null;
      }
    },
    down(){
      var downloadUrl = this.downUrl1;
      var a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'file.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/shopz?id='+this.id

      }

    },
    commitdl(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.qiye == ''){
        this.msg('请填写您的名称','error')
        return false
      }
      if(this.email == ''){
        this.msg('请填写您的手机号','error')
        return false
      }
      axiosInstance({
      	method:'get',
      	params:{
          name:this.qiye,
          email:this.email,
          other:this.other

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoDl'
      })
      .then(res=>{
        this.qiye = '';
        this.email = '';
        this.other = '';
        this.msg('提交成功','success');
        this.dl(2)
      })
      .catch(err=>{

      });
    },
    commitdg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.qiye1 == ''){
        this.msg('请填写您的名称','error')
        return false
      }
      if(this.email1 == ''){
        this.msg('请填写您的手机号','error')
        return false
      }
      axiosInstance({
      	method:'get',
      	params:{
          name:this.qiye1,
          email:this.email1,
          other:this.other1

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoDg'
      })
      .then(res=>{
        this.qiye1 = '';
        this.email1 = '';
        this.other1 = '';
        this.msg('提交成功','success');
        this.dg(2)
      })
      .catch(err=>{

      });
    },
    dg(t){
      this.dinggou2 = t
      this.open(this.dgurl)
    },
    dl(t){
      this.daili2 = t
      this.open(this.dlurl)
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    open(url){
      if(url == '无'){
        return false
      }
      this.ishow = false
      this.video_url = ""
      setTimeout(() => {
        this.ishow = true
        this.video_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },

    startVideo() {
      var that = this

      this.interval2 = setInterval(() => {

        that.list.forEach(function(item, index) {

          if(item['num']<item['nums']){
            item['num'] = item['num']+1;
            that.$set(that.list,index,item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          }else{
            if(item['typed'] == 0){
              item['typed'] = 1;
              item['typec'] = 1;

              item['num'] = 0;
              item['nums'] = item['numz'];
              that.$set(that.list,index,item);
              setTimeout(()=>{
                item['typec'] = 2;
                item['typea'] = 1;
                that.$set(that.list,index,item);
              },400);
              setTimeout(()=>{
                item['typea'] = 0;
                that.$set(that.list,index,item);
              },800);
            }else{
              item['typed'] = 0;
              item['typeb'] = 1;

              item['num'] = 0;
              item['nums'] = item['numt'];
              that.$set(that.list,index,item);

              setTimeout(()=>{
                item['typeb'] = 2;
                item['typea'] = 2;
                that.$set(that.list,index,item);
              },400);
              setTimeout(()=>{
                item['typea'] = 0;
                that.$set(that.list,index,item);
              },800);
            }

          }

        })

      }, 1000);

    },
    startTu() {
      var that = this
      var dl = 0;
      var dg = 0;

      this.interval2 = setInterval(() => {
        if(dl == 5){
          dl = 0
          var ks = Math.floor(Math.random() * (that.dailis.length-1));
          that.daili =  that.dailis[ks]['url'];
        }else{
          dl = dl + 1
        }
        if(dg == 7){
          dg = 0
          var ks = Math.floor(Math.random() * (that.dinggous.length-1));
          that.dinggou =  that.dinggous[ks]['url'];
        }else{
          dg = dg + 1
        }


      }, 1000);

    },
    toPage(name){
      this.$router.push('/'+name);
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:'宇宙一次幂(深圳)机器人有限公司',
          id:this.id

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoListsz'
      })
      .then(res=>{
        this.list = res.data.list;
        this.texts = res.data.texts;
        this.shopkb = res.data.shopkb;
        this.dailis = res.data.shopdl;
        this.dinggous = res.data.shopdg;
        this.daili =  this.dailis[0]['url'];
        this.dinggou =  this.dinggous[0]['url'];
        this.dlurl = res.data.url['dlurl'];
        this.dgurl = res.data.url['dgurl'];
        this.downUrl1 = res.data.zuhe['url1'];
        this.downUrl2 = res.data.zuhe['url2'];
        this.downUrl3 = res.data.zuhe['url3'];
        this.zongjiaPrice = res.data.zuhe['jiage'];
        this.xq = res.data.zuhe
        if(this.zongjiaPrice > 0 && this.xq['status_pay'] != 1){
          this.getOnece1()
        }
        var that = this
        this.list.forEach(function(item, index) {
           item['typed'] = 0;
           item['typec'] = 2;
           item['typeb'] = 2;
           item['typea'] = 0;
           var ks = Math.floor(Math.random() * (that.shopkb.length-1));
           item['bkg'] = that.shopkb[ks]['img'];
        })
        this.startVideo()
        this.startTu()
        this.video_url = this.list[0]['url']
        this.daili2 = 2
        this.dinggou2 = 2
        this.open(this.list[0]['url'])
        var hei = Math.ceil(this.list.length/6)*(this.vwidth+2)

        if(hei > this.screenHeight){
          this.leftheight = this.screenHeight
        }else{
          this.leftheight = Math.ceil(this.list.length/6)*(this.vwidth+2)
        }
      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style lang="scss">
.shop2_wenzi{
	background-image: url("../../assets/image/wenzi.png");
	background-repeat: no-repeat;
	background-size:100% 100%;
	color: #0071a1;
	font-weight: 600;
	font-size: 80%;
	font-family:'hanyi75';
	opacity: 0.8;

}
.grid_b {
    position: absolute;
    z-index: 1010;
    bottom: 2px;
    right: 0px;
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2列布局 */
    grid-template-rows: repeat(2, 1fr);    /* 2行布局 */
    width: 10vw;
    height: 10vw;
    // border: 1px solid transparent;
    // border-radius: 15px;
    // border-image: linear-gradient(1deg, #ab86ff, #c29dff, #a17aff) 1;
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 0 4px 10px rgba(143, 75, 255, 0.5); /* 投影效果 */
    background-color: #0d0d0d;
}

/* 每个小格子样式 */
.cell_b {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid transparent; /* 边框透明，以便显示渐变 */
    border-radius: 10px; /* 可选：为每个小格子添加圆角 */
    border-image: linear-gradient(45deg, #ab86ff, #c29dff, #a17aff) 1;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-color: black; /* 每个小格子的底色 */

}
/* 图标样式 */
.icon_b {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
}

/* 文字样式 */
.text_b {
    text-align: center;
    font-size: 16px;
    color: #fff;
    margin: 0;
}






ul li{
  font-family: 'hanyi75',sans-serif;
  font-weight: 400;
}
@keyframes float {
  0% { transform: translate(20px, 20px); }
  20% { transform: translate(900px, 80px); }
  40% { transform: translate(750px, 500px); }
  60% { transform: translate(900px, 900px); }
  80% { transform: translate(50px, 950px); }
  100% { transform: translate(20px, 20px); }
}

.float-animation {
  /* display: inline-block; */
  animation: float 30s infinite;
}
@keyframes float1 {
  0% { transform: translate(950px, 900px); }
  20% { transform: translate(20px, 850px); }
  40% { transform: translate(300px, 500px); }
  60% { transform: translate(20px, 20px); }
  80% { transform: translate(950px, 50px); }
  100% { transform: translate(950px, 900px); }
}

.float-animation1 {
  /* display: inline-block; */
  animation: float1 30s infinite;
}
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;
}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shopz.vue